/// <amd-module name="Feed/Core/Redux/FeedHub/FeedHubModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";

import { getTfsPageDataModule } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataModule";

import { getFeedNavigationModule } from "../Navigation/FeedNavigationModule";
import { IFeedHubViewState } from "./FeedHubContracts";
import { feedStateReducer, feedUIReducer } from "./FeedHubReducers";
import rootSaga from "./FeedHubSagas";

export const FeedHubRootModule: ISagaModule<IFeedHubViewState> = {
    id: "feed-hub-root",
    reducerMap: {
        data: feedStateReducer,
        ui: feedUIReducer
    },
    sagas: [rootSaga]
};

export const getFeedHubModules = () => [getTfsPageDataModule(), getFeedNavigationModule(), FeedHubRootModule];
